import { LoruleRequestConfig, WebUtils } from '@galaxy/lorule-react-commons';
import { buildConfig, triggerDownload } from './commonApiUtil';

export const printActionMemo = async (
    config: LoruleRequestConfig,
    amId: number,
    user: boolean = true,
) => {
    const response = await WebUtils.requestWithHeaders(
        buildConfig(config, `/actionmemo/${amId}/detail?user=${user}`),
        'GET',
        null,
        {},
    );
    if (response) {
        await triggerDownload(response);
    }
};

export const printDetail = async (
    config: LoruleRequestConfig,
    amId: number,
    detailId: number,
    user: boolean = true,
) => {
    const response = await WebUtils.requestWithHeaders(
        buildConfig(config, `/actionmemo/${amId}/detail/${detailId}?user=${user}`),
        'GET',
        null,
        {},
    );
    if (response) {
        await triggerDownload(response);
    }
};
